import { Fragment, jsx } from "react/jsx-runtime";
import { CdnIcon } from "../CdnIcon/index.js";
import { Span } from "../Text/index.js";
import { AutocompleteListItem } from "./AutocompleteListItem/AutocompleteListItem.js";
import { autocompleteListItemVariants } from "./AutocompleteListItem/AutocompleteListItem.variant.js";
const ITEM_LOCATION_TYPES = {
    AIRPORT: 'flight',
    POI: 'pin_drop',
    GEO: 'location_on',
    HOTEL: 'hotel',
    NEIGHBOURHOOD: 'home_work'
};
function getIconName(itemLocationType) {
    return ITEM_LOCATION_TYPES[itemLocationType] || 'location_city';
}
function AutocompleteContainer({ items, isOpen, highlightedIndex, highlightedIndexWithKeyArrow, selectedItem, getItemProps }) {
    const { groupHeaderWrapper } = autocompleteListItemVariants();
    return /*#__PURE__*/ jsx(Fragment, {
        children: isOpen && items.length > 0 && items.map((item, index)=>item.isGroupHeader ? /*#__PURE__*/ jsx("div", {
                className: groupHeaderWrapper(),
                children: /*#__PURE__*/ jsx(Span, {
                    textStyle: "body3",
                    color: "primary-13",
                    children: item.itemName
                })
            }, item.id ?? `${item.itemName}-${index}`) : /*#__PURE__*/ jsx(AutocompleteListItem, {
                firstLine: item.displayLine1 ?? item.itemName,
                secondLine: item.displayLine2 ?? void 0,
                leftNode: item.type && /*#__PURE__*/ jsx(CdnIcon, {
                    palette: "primary",
                    shade: "10",
                    iconName: getIconName(item.type),
                    size: "24"
                }),
                isHighlighted: highlightedIndex === index && 'GEO' !== item.type,
                isHighlightedIndexWithKeyArrow: highlightedIndexWithKeyArrow === index,
                isSelected: selectedItem?.itemName === item.itemName && 'GEO' !== item.type,
                ...getItemProps({
                    item,
                    index
                })
            }, item.id ?? `${item.itemName}-${index}`))
    });
}
export { AutocompleteContainer };
